import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconDatabaseOff = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M2.293 2.293a1 1 0 0 1 1.414 0L19.94 18.525q.029.026.056.056l1.712 1.712a1 1 0 0 1-1.414 1.414l-1.162-1.162c-.713.397-1.585.71-2.533.942-1.341.328-2.92.513-4.598.513-2.297 0-4.422-.347-6.008-.942-.79-.296-1.498-.673-2.027-1.142C3.438 19.448 3 18.803 3 18V6c0-.46.143-.868.365-1.22L2.293 3.706a1 1 0 0 1 0-1.414M5 8.616V12c0 .026.01.17.292.42.28.248.744.518 1.402.765C8.004 13.675 9.88 14 12 14q.291 0 .578-.008L8.257 9.67C7.004 9.437 5.878 9.08 5 8.616m9.449 7.247c-.778.09-1.6.137-2.449.137-2.297 0-4.422-.347-6.008-.942A9 9 0 0 1 5 14.616V18c0 .026.01.17.292.42.28.248.744.518 1.402.765C8.004 19.675 9.88 20 12 20c1.539 0 2.956-.17 4.123-.456a9.7 9.7 0 0 0 1.514-.492zM7.271 2.546C8.64 2.198 10.267 2 12 2c2.297 0 4.422.347 6.008.942.79.296 1.498.673 2.027 1.142C20.562 4.552 21 5.197 21 6v10a1 1 0 1 1-2 0v-1.383a8 8 0 0 1-.62.294 1 1 0 0 1-.781-1.842c.559-.237.941-.484 1.168-.705.225-.218.233-.34.233-.364V8.616a8 8 0 0 1-.637.3c-1.398.59-3.276.966-5.334 1.06a1 1 0 1 1-.092-1.997c1.897-.087 3.528-.433 4.65-.905.563-.238.949-.486 1.178-.707.227-.22.235-.342.235-.367 0-.026-.01-.17-.292-.42-.28-.248-.744-.518-1.402-.765C15.996 4.324 14.12 4 12 4c-1.589 0-3.048.182-4.237.484a1 1 0 0 1-.492-1.938"
            clipRule="evenodd"
        />
    </svg>
);
